export const setupQuantityControls = () => {
  const updateButtonState = (container) => {
    const input = container?.querySelector("input[type='number']");
    const decrementButton = container?.querySelector(".quantity-decrement");
    const incrementButton = container?.querySelector(".quantity-increment");

    if (!input) return;

    const currentValue = parseInt(input.value, 10);
    const minValue = parseInt(input.min, 10) || 0;
    const maxValue = parseInt(input.max, 10) || Infinity;

    decrementButton?.classList.toggle("disabled", currentValue <= minValue);
    incrementButton?.classList.toggle("disabled", currentValue >= maxValue);
  };

  const handleButtonClick = (event) => {
    const decrementButton = event.target.closest(".quantity-decrement");
    const incrementButton = event.target.closest(".quantity-increment");
    const container = (decrementButton || incrementButton)?.closest(
      ".quantity"
    );
    const input = container?.querySelector("input[type='number']");

    if (input) {
      decrementButton && input.stepDown();
      incrementButton && input.stepUp();

      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));

      updateButtonState(container);
    }
  };

  const handleInputChange = (event) => {
    const input = event.target.closest("input[type='number']");
    const container = input?.closest(".quantity");
    if (container) updateButtonState(container);
  };

  const handleCartUpdate = () => {
    document.querySelectorAll(".quantity").forEach(updateButtonState);
  };

  document.addEventListener("click", handleButtonClick);
  document.addEventListener("input", handleInputChange);
  document.body.addEventListener("updated_cart_totals", handleCartUpdate);

  document.querySelectorAll(".quantity").forEach(updateButtonState);
};
